// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header__cell-f5GwO";
export { _1 as "__esModule", _2 as "header__cell" }
export default { "__esModule": _1, "header__cell": _2 }
